export const QUALIFICATION_RENDER_TYPE = {
  DROPDOWN: 1,
  FILE_UPLOAD: 2,
  SEARCH: 3,
  RANGE: 4,
  MULTI_SELECT_BUTTON: 5,
} as const;
